var n=function(n,t){var l=null;return function(){for(var u=[],r=0;r<arguments.length;r++)u[r]=arguments[r];null===l&&(n.apply(this,u),l=setTimeout(function(){l=null},t))}};export{n as throttle};
//# sourceMappingURL=index.js.map
